import React from 'react';
import DataPage from "types/DataPage";
import Paginator from "components/Paginator/Paginator";
import DataResource from "types/DataResource";

// Types ----

type TableProps = {
  paginationData?: DataPage<any> | DataResource<any> | null
  setPage?: (page: number) => void
  isFetching?: boolean
  children: React.ReactNode
}

// Component ----

function Table({children, paginationData, setPage, isFetching}: TableProps) {

  return (
    <div className="relative flex flex-col">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 pb-36">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow border-b border-gray-200 rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              {children}
            </table>

            {paginationData && setPage &&
              <Paginator data={paginationData} setPage={setPage} isFetching={isFetching}/>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

// Export ----

export default Table;